import { Box, ModalHeader, useModal } from '@wrisk/ui-components'
import { isNil, negate } from 'lodash-es'
import React from 'react'

import { usePrincipal } from '../../application/authentication'
import { FormValidationError } from '../../application/formBuilder/validation/types'
import { FormValidationResult } from '../../clients/api/clients/formValidation'
import { Data } from '../../domain'
import {
  tFormValidation,
  useWriskTranslation,
} from '../../infrastructure/internationalisation'
import { useApiErrorHandlingAsyncCallback } from '../auth'

export interface FormValidationProps {
  validationProfile: string | undefined
  onSuccess: (data: Data) => Promise<unknown>
}

export const useFormValidation = ({
  validationProfile,
  onSuccess,
}: FormValidationProps) => {
  const { t } = useWriskTranslation()
  const { show } = useModal()

  const { apiClient } = usePrincipal()

  return useApiErrorHandlingAsyncCallback(async (data: Data) => {
    const result: FormValidationResult = validationProfile
      ? await apiClient.validateForm(validationProfile, data)
      : { success: true, errors: [] }

    if (result.success) {
      await onSuccess(data)
    } else {
      const errorMessage: FormValidationError | undefined = result.errors
        .map((error) =>
          t<string, FormValidationError>(tFormValidation(error), {
            returnObjects: true,
            defaultValue: null,
          }),
        )
        .find(negate(isNil))

      if (errorMessage) {
        show({
          content: (
            <Box>
              <ModalHeader
                header={errorMessage.header}
                subheader={errorMessage.message}
              />
            </Box>
          ),
        })
      } else {
        console.error(`No error message found for ${result.errors[0]}`)
      }
    }
  })
}
